var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("关于我们")]),_c('div',{staticClass:"nav-links"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/about/company"}},[_vm._v("公司介绍")]),_c('router-link',{staticClass:"nav-link",attrs:{"to":"/about/why-us"}},[_vm._v("为什么选择我们")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }